module.exports = __webpack_public_path__ + "img/ban.12aad21d.png";